module.exports = __webpack_public_path__ + "img/preview-role.d77530e9.png";